module.exports = __webpack_public_path__ + "static/img/gwas_doc.83595ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gwas_doc.png
// module id = YWdj
// module chunks = 1